import { PUBLIC_PATH, PUBLIC_SITE_URL } from '$env/static/public';

/**
 * Absolute public base: origin + SvelteKit base path (no trailing slash).
 * Returns null if PUBLIC_SITE_URL is not set (omit canonical/OG absolute URLs).
 */
export function getAbsoluteSiteBase(): string | null {
	const origin = (PUBLIC_SITE_URL || '').trim().replace(/\/$/, '');
	if (!origin) return null;
	const path = (PUBLIC_PATH || '').trim();
	const base = `${origin}${path}`.replace(/\/$/, '');
	return base || null;
}

/** Absolute URL for a pathname (must start with `/`). Trailing slash preserved. */
export function absoluteUrl(pathname: string): string | null {
	const base = getAbsoluteSiteBase();
	if (!base) return null;
	const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
	return `${base}${path}`;
}
